import { useBusinessSettingsContext } from '../../hooks/useBusinessSettingsContext'
import Cart from '../Cart'
import FashionCart from '../../storefronts/indumentaria-femenina/FashionCart'

function PublicCart() {
  const { activeProfile, loading } = useBusinessSettingsContext()

  if (loading && !activeProfile) {
    return null
  }

  if (activeProfile?.rubro === 'indumentaria' && (activeProfile?.subrubro || 'femenina') === 'femenina') {
    return <FashionCart />
  }

  return <Cart />
}

export default PublicCart
